/** Common stop words excluded from fuzzy quote / PDF word-separate search. */
export const SEARCH_STOP_WORDS = new Set([
  'a', 'an', 'the', 'and', 'or', 'of', 'to', 'in', 'on', 'for', 'is', 'was', 'are', 'were',
  'be', 'been', 'being', 'have', 'has', 'had', 'do', 'does', 'did', 'will', 'would', 'could',
  'should', 'may', 'might', 'must', 'shall', 'can', 'this', 'that', 'these', 'those', 'it',
  'its', 'as', 'at', 'by', 'from', 'with', 'not', 'no', 'but', 'if', 'then', 'than', 'so',
  'into', 'over', 'after', 'before', 'between', 'under', 'again', 'further', 'once', 'here',
  'there', 'when', 'where', 'why', 'how', 'all', 'each', 'few', 'more', 'most', 'other',
  'some', 'such', 'only', 'own', 'same', 'too', 'very', 'just', 'also', 'about', 'above',
  'below', 'up', 'down', 'out', 'off', 'any', 'both', 'he', 'she', 'they', 'them', 'his',
  'her', 'their', 'we', 'you', 'your', 'our', 'my', 'me', 'him', 'who', 'whom', 'which',
  'what', 'while', 'during', 'through', 'against', 'because', 'until', 'although',
]);

/**
 * Tokenize text into distinct content words (lowercase, punctuation stripped, stop words removed).
 * @param {string} text
 * @param {{ minLength?: number }} [options]
 * @returns {string[]}
 */
export function tokenizeContentWords(text, { minLength = 1 } = {}) {
  if (!text?.trim()) {
    return [];
  }

  const seen = new Set();
  const words = [];

  for (const raw of text.trim().split(/\s+/)) {
    const word = raw.replace(/[^a-zA-Z0-9-]/g, '').toLowerCase();
    if (word.length < minLength || SEARCH_STOP_WORDS.has(word) || seen.has(word)) {
      continue;
    }
    seen.add(word);
    words.push(word);
  }

  return words;
}

const escapeRegex = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

/**
 * Build a word-separate regex pattern for OCR/scanned PDFs where sentence search fails.
 * @param {string} phrase
 * @returns {string|null} e.g. "quick|brown|fox", or null if no searchable words remain
 */
export function buildWordSeparateSearchPattern(phrase) {
  const words = tokenizeContentWords(phrase, { minLength: 2 }).map(escapeRegex);

  if (words.length === 0) {
    return null;
  }

  return words.join('|');
}
